import { render, staticRenderFns } from "./ContentViewSettingsRadio.vue?vue&type=template&id=8fa49e90&scoped=true&"
import script from "./ContentViewSettingsRadio.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsRadio.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsRadio.vue?vue&type=style&index=0&id=8fa49e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa49e90",
  null
  
)

export default component.exports